import React from "react";
import styled from "styled-components";
import { Fade } from "react-reveal";
import { WppButton } from "./chatButton";

const SecondContent = () => {
  return (
    <SecondContainer>
      <TextGroups>
        <Fade left>
          <TextGroup1>
            <h1>Nossas Unidades.</h1>
            <h2>
              Nós oferecemos clínicas especializadas para homens, mulheres e
              menores de idade, todas com fácil acesso, instalações excelentes e
              áreas de lazer. Além disso, possuímos uma equipe de profissionais
              altamente qualificados, incluindo médicos psiquiatras, psicólogos,
              nutricionistas, terapeutas e outros especialistas.
            </h2>
          </TextGroup1>
        </Fade>
        <SecondaryContainer>
          <Fade left>
            <TextSubGroup>
              <span>
                <img
                  src="https://a2723d7d63.cbaul-cdnwnd.com/c9a4f07398f99ecd18a2ed68de83a17a/200000000-8a6d68a6d9/images%20-%202021-09-12T122443.231.jpeg?ph=a2723d7d63"
                  alt="unidade feminina"
                />
              </span>
              <li>
                <h1>Unidades Femininas</h1>
                <h2>
                  Nossa unidade de reabilitação feminina conta com equipe
                  especializada no tratamento de dependências quimicas. As
                  pacientes recebem atendimento personalizado e são acolhidas em
                  acomodações confortáveis e seguras para a recuperação.
                </h2>
              </li>
            </TextSubGroup>
          </Fade>
          <Spacer></Spacer>
          <Fade right>
            <TextSubGroup>
              <span>
                <img
                  src="https://a2723d7d63.cbaul-cdnwnd.com/c9a4f07398f99ecd18a2ed68de83a17a/200000001-eeee1eeee3/images%20-%202021-09-12T122425.726.jpeg?ph=a2723d7d63"
                  alt="unidade masculina"
                />
              </span>

              <li>
                <h1>Unidades Masculinas</h1>
                <h2>
                  Nossa unidade de reabilitação masculina é conduzida por uma
                  equipe de profissionais especializados em tratamentos de
                  dependências químicas. Os pacientes são acolhidos em
                  acomodações seguras e confortáveis, garantindo um ambiente
                  tranquilo para a recuperação.
                </h2>
              </li>
            </TextSubGroup>
          </Fade>
        </SecondaryContainer>
      </TextGroups>
    </SecondContainer>
  );
};
export default SecondContent;
const Spacer = styled.span`
  height: 20px;
`;
const SecondaryContainer = styled.div`
  display: flex;
  width: 92%;
  margin: auto;
  border-top: 2px solid #fff;
  padding-top: 8px;

  @media (max-width: 900px) {
    width: 98%;
    flex-wrap: wrap;
  }
`;

const SecondContainer = styled.div`
  width: 100%;
  min-height: 600px;
  height: auto;
  background-color: #537bae;
  padding: 85px 20px;
  color: white;
  position: relative;

  h1 {
    font-weight: bold;
  }
  @media (max-width: 1500px) {
    padding: 40px 0px;
    padding-bottom: 60px;
  }
`;
const TextGroups = styled.div`
  width: 80%;
  margin: auto;

  @media (max-width: 900px) {
    width: 98%;
    min-height: 0px;
    height: auto;
  }
`;
const TextGroup1 = styled.div`
  width: 100%;
  display: column;
  text-align: center;
  font-family: "Jost", sans-serif;
  margin-bottom: 25px;
  h1 {
    font-size: 2.625rem;
    line-height: 1.28571;
    padding-bottom: 1.875rem rem;
  }
  h2 {
    color: hsla(0, 0%, 100%, 0.7);
    width: 70%;
    margin: auto;
    font-size: 1.5rem;
    line-height: 1.5;
  }
  @media (max-width: 900px) {
    h1 {
      font-size: 2.1rem;
      line-height: 1.1;
      padding-bottom: 1.5rem;
    }
    h2 {
      width: 100%;
      font-size: 1.2rem;
      line-height: 1;
    }
  }
`;

const TextSubGroup = styled.div`
  display: flex;
  width: 92%;
  height: 100%;
  margin-top: 30px;
  font-family: "Jost", sans-serif;
  background-color: #ffffffca;
  filter: drop-shadow(0px 3px 5px #414141);
  border-radius: 5px;
  &:hover {
    filter: drop-shadow(0px 0px 5px #202020);
  }
  span {
    height: 100%;
    width: 25%;
    position: relative;
    img {
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      height: 100%;
      object-fit: cover;
      width: 100%;
      z-index: 100;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  }

  li {
    width: 75%;
    list-style: none;
    display: column;
    margin-left: 12px;
    margin-right: 10%;
    h1 {
      color: #3d73a3;
      margin-top: 5px;
      font-size: 1.25rem;
      line-height: 1.4;
    }
    h2 {
      color: #000000;
      margin-top: 5px;
      font-size: 1rem;
      line-height: 1.2;
    }
  }

  @media (max-width: 900px) {
    width: 100%;
  }
`;
